import React from 'react';
import StyledButton from 'common/StyledButton';
import css from './RequestHelpError.scss';

/**
 * @returns {JSX.Element} an error page that gives the user the option to go back to the home page
 */
function RequestHelpError() {
    return (
        <div className={css['container']}>
            <img src="../images/alert.svg" />
            <h1>Oops! Something went wrong...</h1>
            <p>You do not have permission to see this page.</p>
            <StyledButton onClick={() => window.location = '../instructor/index.html'}>
                Go to Home
            </StyledButton>
        </div>
    );
}

export default RequestHelpError;
